var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_60_215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 25.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2344 29.5781H34.8906V25.5938H38.875V22.9375H34.8906V18.9531H32.2344V22.9375H28.25V25.5938H32.2344M26.9219 41.5312C25.4609 41.5312 24.2656 42.7266 24.2656 44.1875C24.2656 45.6484 25.4609 46.8438 26.9219 46.8438C28.3828 46.8438 29.5781 45.6484 29.5781 44.1875C29.5781 42.7266 28.3828 41.5312 26.9219 41.5312ZM40.2031 41.5312C38.7422 41.5312 37.5469 42.7266 37.5469 44.1875C37.5469 45.6484 38.7422 46.8438 40.2031 46.8438C41.6641 46.8438 42.8594 45.6484 42.8594 44.1875C42.8594 42.7266 41.6641 41.5312 40.2031 41.5312ZM27.1875 37.2812V37.1484L28.3828 34.8906H38.2109C39.1406 34.8906 40.0703 34.3594 40.4688 33.5625L45.6484 24.2656L43.3906 22.9375L38.2109 32.2344H28.9141L23.3359 20.2812H18.9531V22.9375H21.6094L26.3906 33.0313L24.5312 36.2188C24.3984 36.6172 24.2656 37.0156 24.2656 37.5469C24.2656 39.0078 25.4609 40.2031 26.9219 40.2031H42.8594V37.5469H27.4531C27.3203 37.5469 27.1875 37.4141 27.1875 37.2812Z",
    fill: "#1D7000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_60_215",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60_215",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCart);
export default __webpack_public_path__ + "static/media/imgCart.7a5c82b0f468d33f7b5b68d89e8aba3a.svg";
export { ForwardRef as ReactComponent };